import { useQuery } from "@apollo/client";
import { GetDirectDepositFilesQuery, GetDirectDepositFilesQueryVariables } from "generated/graphql";
import queries from "Shared/queries";
import React from "react";

const useDirectDepositFiles = () => {
  const [page, setPage] = React.useState(1);
  const rowsPerPage = parseInt(
    process.env.REACT_APP_DATA_EXCHANGE_PER_PAGE!,
    10
  );
  const { data, refetch, loading } = useQuery<GetDirectDepositFilesQuery, GetDirectDepositFilesQueryVariables>(
    queries.GET_DIRECT_DEPOSIT_FILES_QUERY,
    {
      variables: {
        page,
        perPage: rowsPerPage,
      },
      fetchPolicy: "no-cache",
    }
  );

  const pendingCount = data?.directDepositUpdateFiles?.pendingUpdateCount || 0;

  React.useEffect(() => {
    refetch({ page });
  }, [page, refetch]);

  return {
    data,
    loading,
    page,
    setPage,
    rowsPerPage,
    pendingCount,
    refetch,
  };
};

export default useDirectDepositFiles;
